import { List, ListItemIcon, ListItemText, Collapse, Tooltip, useTheme, ListItemButton, styled, tooltipClasses } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { IfTrue, IsNullOrUndefined } from '../Helpers';
import IconButtonEx from './IconButtonEx';

const PADDING_INCREMENT: number = 0;
export interface MenuListExItemData {
    key: string,
    onClick: () => void | Promise<any>,
    displayText: string,
    icon: React.ReactNode,
    children: MenuListExItemData[]
}

export interface MenuListExItemProps {
    item: MenuListExItemData;
    padding: number;
    showToolTip: boolean;
}

const LargeTooltip = styled(Tooltip)(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]:{
        fontSize: theme.typography.pxToRem(16),
    },
}));


export const MenuListExItem = ({ item, padding, showToolTip }: MenuListExItemProps) => {
    const theme = useTheme();
    const [open, setOpen] = useState(true);
    const location = useLocation();

    if (IsNullOrUndefined(item.onClick) && item.children.length === 0)
        return null;
    return IsNullOrUndefined(item.onClick) ? (
        <>
            <ListItemButton key={item.key} sx={{ color: theme.palette.info.main, minHeight: { xs: 48, lg: 40 } }} onClick={() => setOpen(!open)} selected={location.pathname === item.key} style={{ paddingLeft: `${padding}px` }}>
                <ListItemText color='#ff0000' primary={item.displayText} />
                <IconButtonEx size='small' onClick={() => setOpen(!open)}>{open ? <ExpandLess /> : <ExpandMore />}</IconButtonEx>
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <MenuListEx options={item.children} padding={padding + PADDING_INCREMENT} />
            </Collapse>
        </>
    ) : (

        <ListItemButton key={item.key} onClick={item.onClick} selected={location.pathname === item.key} sx={{ minHeight: { xs: 48, lg: 40 } }} style={{ paddingLeft: `${padding}px` }}>
            {IfTrue(showToolTip, () =>
                <LargeTooltip title={item.displayText} placement="top-start">
                    <ListItemIcon>{item.icon}</ListItemIcon>
                </LargeTooltip>
            )}
            {IfTrue(!showToolTip, () => <ListItemIcon>{item.icon}</ListItemIcon>)}
            <ListItemText primary={item.displayText} />
        </ListItemButton>

    );
}

export interface MenuListExProps {
    options: MenuListExItemData[];
    padding?: number;
    showToolTip?: boolean;
}
const MenuListEx = ({ options, padding = 25, showToolTip = false }: MenuListExProps) => {
    const theme = useTheme();
    var props = padding === 0 ? { component: "nav" } : { component: "div", disablePadding: true };

    return (
        <List sx={{
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper,
        }} {...props}>
            {options.map((item, index) => (
                <MenuListExItem key={item.key} item={item} padding={padding} showToolTip={showToolTip} />
            ))}
        </List>
    )
};

export default MenuListEx;
